/* eslint-env brwoser, es6 */
import $ from 'jquery'
import rivets from 'rivets'
import rivvetsaddtions from './rivets-additions'
import { calculateData, readProducts, convertProductsToRatedProducts} from './matrixfunctions'

export default function(dom, opts) {
	const options = {
		"appid": "upcspquiz",
		"sliderSel": ".js--slidercontainer",
		"products": [],
		"filterBar": {},
		"rules": [],
		"filtersExclusive": ["risk", "time", "objective"],

		...opts
	}

	const scope = {
		show: true,
		products: Object
								.keys(options.products)
								.map((key, i, arr) => {
									var p = {...options.products[key], order: arr.length - i, recommended: false}
									if (p["objective"] instanceof Array) {
										p["objective"] = p["objective"].join(",")
									}
									return p
								}),
		filters: [],
		filterBar: options.filterBar,
		filterlist: Object
			.keys(options.filterBar)
			.reduce((p, c) => {
				p[c] = { id: c, open: false}
				return p
			}, {}),
		moreProducts: false,
		recommendId: -1,

		onAddFilter: onAddFilter,
		onRemoveFilter: onRemoveFilter,
		onMoreProducts: onMoreProducts,
		onMoreProductsClose: onMoreProductsClose,
		onFilterlistToggle: onFilterlistToggle
	}

	let skipLocationChange = false

	initialize()


	//functions
	function initialize() {

			checkLocationHash()
			updateFilterProducts()

			console.info("options", options)

			rivets.bind(dom, {
				scope: scope
			}, {
				formatters: {
					"ubsspfilter": function(product, filters) {
						return product.show || filters.length == 0 //filters.reduce((p, c) => p && product[c.type] == c.value, true)
					},
					"ubsfilteractive": function(id, filters) {
						const [type, value] = id.split("=")
						return filters.find((filter) => filter.type==type && filter.value == value, true) && true
					}
				}
			})

			$(window).on("hashchange", checkLocationHash)
	}

	function onAddFilter(e, m) {
		const filter = m.filter
		const [type, value] = filter.id.split("=")

    console.log(type, value)

		const found = scope.filters
			.find(
        (f) => {
          f.type == type && f.value == value
        }
      )

		//check filter does not exist
		if (!found) {
			//we check if the filter is exclusive
			if (options.filtersExclusive.indexOf(type) >= 0) {
				scope.filters = scope.filters.filter(f => f.type != type)
			}

			scope.filters.push({
				type: type,
				value: value,
				title: filter.title,
				typetitle: filter.typetitle
			})
		}
		updateFilterProducts()
		updateLocationHash()
	}

	function onRemoveFilter(filter, e, m) {
		scope.filters.splice(scope.filters.indexOf(filter),1)
		updateLocationHash()
		updateFilterProducts()
	}

	function onMoreProducts() {
		scope.moreProducts = !scope.moreProducts;
	}

	function onMoreProductsClose() {
		scope.moreProducts = false
	}

  function groupByFirstValue (list) {
    const result = [];
    list.forEach((element) => {
        if (!result.includes(element[0])) {
          result.push(element[0]);
        }
    })
    return result;
  };

	function updateFilterProducts() {
		if (scope.filters.length > 0) {

			//calculate products with current filter
			const filterList = scope.filters.map(f => [f.type, f.value])
			const prepProducts = convertProductsToRatedProducts(scope.products);
      const filterCategories = groupByFirstValue(filterList);

			if(scope.filters.length < 6) {
				//only display 3 except no filters and when objective in combination with another is the only active filter @TODO: improve solution
				var tmpproducts = calculateData(prepProducts, options.rules, filterList);
				var rateproducts = new Array(); //reset prep Array

				tmpproducts.forEach(function(item){
          let showprod = true;

          for (const property in item.ratingMap) {
            if (item.ratingMap[property] < 1) {
                showprod = false;
            }
          }

					if (filterCategories.length && showprod) {
						rateproducts.push(item); //only push items with perfect score
					}
				});
			} else {
				//just display the top 3 when more than two filters
				var rateproducts = calculateData(prepProducts, options.rules, filterList).slice(0,3);
			}

			const ratedProducts = rateproducts;

			scope.products.forEach((p, i) => {
				const rp = ratedProducts.find(rp => rp.product.id == p.id)
				if (rp) {
					p.order = ratedProducts.indexOf(rp)
					p.rating = rp.rating;
					p.show = true;
				} else {
					p.order = i;
					p.show = false;
				}
			})
		} else {
			scope.products.forEach((product, i) => {
				product.order = 1 + i
			})
		}

	}


	function updateLocationHash() {
		skipLocationChange = true
		let hashStr = ""
		if(scope.filters.length) {
			hashStr = "#/filter/" + scope.filters
				.map(f => f.type + "=" +f.value)
				.join("&")
		}

		location.hash = hashStr
		skipLocationChange = false
	}

	function checkLocationHash() {
		if (skipLocationChange) {
			return
		}
		//parse filter from url
		const hash = location.hash
		const filterNeedle = "#/filter/"
		const recommendNeedle = "/recommend/"
		if (hash.length>1) {
			if (hash.indexOf(filterNeedle) == 0) {
				//create map for filter check
				const filtermap = Object
					.values(scope.filterBar)
					.reduce((p, c) => {
						c.forEach(f => p[f.id]=f)
						return p;
					},{})

				//parse addressbar
				const last = hash.indexOf("/", filterNeedle.length)
				const str = hash.substring(filterNeedle.length, last > -1 ? last : undefined)
				const filters = str
					.split("&")
					.map(f => f.split("="))
					.map(f => filtermap[f[0]+"="+f[1]])
					.filter((f, i, a) => f != null && a.indexOf(f) == i)


				const recommendPos = hash.indexOf(recommendNeedle)
				if (recommendPos > 0) {
					const recommendStr = hash.substring(recommendPos + recommendNeedle.length)
					if (/[0-9]{1,4}/.test(recommendStr)) {
						const recommendId = parseInt(recommendStr)
						const recommendProd = scope.products.find((p) => {
							return p.id == recommendId
						})
						if (recommendProd) {
							recommendProd.recommended = true
						}
					}
				}

				//insert into filters
				scope.filters = []
				filters.forEach(f => {
					const [type, value] = f.id.split("=")
					scope.filters.push({
						type,
						value,
						title: f.title,
						typetitle: f.typetitle
					})
				})
			}
		}
	}
	function onFilterlistToggle(e, m) {
		e.preventDefault()
		m.category.open = ! m.category.open
	}


}
